module.exports = __webpack_public_path__ + "static/img/dev1 (4).c869c59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dev1 (4).png
// module id = FicI
// module chunks = 1